export const OBJECT_ID = 'objectid';
export const ROW_ID = 'rowid';